import { render, staticRenderFns } from "./PsPatientsDetail.vue?vue&type=template&id=d4ae9166&scoped=true&"
import script from "./PsPatientsDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsDetail.vue?vue&type=style&index=0&id=d4ae9166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae9166",
  null
  
)

export default component.exports